import { animate, keyframes, style, transition, trigger } from '@angular/animations';

export const pulse = trigger('pulse', [
  transition('* => *', [
    animate('1s', keyframes ( [
      style({ opacity: 0.1, offset: 0.1 }),
      style({ opacity: 0.6, offset: 0.2 }),
      style({ opacity: 1,   offset: 0.5 }),
      // style({ opacity: 0.2, offset: 0.7 })
    ]))
  ])
]);
